module.exports = __webpack_public_path__ + "img/purple-1-diamond-solid.cc17537d.svg";